import { Component, HostListener, OnInit } from "@angular/core";
import { HeaderService } from "src/app/services/header.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  width: any;
  podeVerTelaExcelLicenciamentoBci = false;

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.width = window.innerWidth;
  }

  constructor(public service: HeaderService) {}

  public underline = true;
  FormataLinkTrue() {
    this.underline = true;
  }

  FormataLinkFalse() {
    this.underline = false;
  }
  temPerfil(permissao: string) {
    let usuarioLogado = JSON.parse(window.localStorage.getItem("usuario"));
    const role = usuarioLogado?.role;

    //const role = this.permissionService.getPermission();
    return role?.some((x) => x == permissao);
  }

  ngOnInit(): void {
    this.width = window.innerWidth;

    /*
    let perfilEstaduais = false;
    let perfilABR = false;
    let usuarioLogado = JSON.parse(window.localStorage.getItem("usuario"));
    let perfis = usuarioLogado?.role;
    if(perfis !== null && perfis !== undefined){
      perfilEstaduais = (perfis.indexOf("ESTADUAL") > -1);
      perfilABR = (perfis.indexOf("ABR") > -1);
    }
    if(perfilEstaduais || perfilABR){
      this.podeVerTelaExcelLicenciamentoBci = true;
    }
  */
  }
}
